import axios from 'axios'
import { config, url } from '../../../index'

const state = () => ({
  tableHeaders: [
    {
      title: 'Название',
      isSortable: false
    }
  ],
  employments: [],
  isLoading: true,
  pagination: {
    pageList: {
      active: false,
      pages: []
    },
    currentTake: 10,
    currentPage: 1,
    lastPage: 0
  },
  updateModal: {
    active: false,
    employment: {},
    validation: {}
  },
  createModal: {
    active: false,
    newEmploymentName: '',
    validation: {}
  }
})

const getters = {
  employments: state => state.employments,
  employmentListIsLoading: state => state.isLoading,
  employmentListTableHeaders: state => state.tableHeaders,
  employmentListUpdateModal: state => state.updateModal,
  employmentListCreateModal: state => state.createModal
}

const mutations = {
  // получение списка всех видов занятости
  GET_EMPLOYMENTS: (state, employments) => {
    // добавляем к каждому объекту свойство для отрисовки состояния меню (ред./удалить)
    state.employments = employments.map(employment => {
      return {
        ...employment,
        isControlsActive: false
      }
    })
    // убираем флаг "контент загружается"
    state.isLoading = false
  },
  // вкл/выкл меню (редактировать/удалить)
  EMPLOYMENT_LIST_TOGGLE_CONTROLS: (state, itemId) => {
    state.employments.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  // выкл меню (редактировать/удалить) при клике вне элемента
  CLOSE_EMPLOYMENT_LIST_CONTROLS: (state) => {
    state.employments.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  // показ модалки для редактирования записи
  SHOW_EMPLOYMENT_LIST_UPDATE_MODAL: (state, employmentId) => {
    state.updateModal.active = true
    // помещаем в модалку копию объекта чтобы редактирование не затрагивало таблицу
    const copies = state.employments.map(employment => ({ ...employment }))
    state.updateModal.employment = copies.filter(employment => {
      return employment.id === employmentId
    }).shift()
  },
  SET_UPDATED_EMPLOYMENT_NAME: (state, name) => {
    state.updateModal.employment.name = name
  },
  SHOW_EMPLOYMENT_LIST_CREATE_MODAL: (state) => {
    state.createModal.active = true
  },
  SET_CREATED_EMPLOYMENT_NAME: (state, name) => {
    state.createModal.newEmploymentName = name
  },
  // закрытие всех модалок
  CLOSE_EMPLOYMENT_LIST_MODALS: (state) => {
    // модалка редактирвоания
    state.updateModal.active = false
    state.updateModal.employment = {}
    // модалка создания
    state.createModal.active = false
    state.createModal.newEmploymentName = ''
  },
  SET_EMPLOYMENT_LIST_MODAL_VALIDATION: (state, validationData) => {
    switch (validationData.modal) {
      case 'create':
        state.createModal.validation = validationData.validation
        break
      case 'update':
        state.updateModal.validation = validationData.validation
        break
      default:
        state.createModal.validation = {}
        state.updateModal.validation = {}
    }
  },
  // записть в стейт состояния пагинации
  SET_EMPLOYMENT_LIST_PAGINATION: (state, paginationData) => {
    state.pagination.currentPage = paginationData.current_page
    state.pagination.lastPage = paginationData.last_page
    // заполняем массив номерами страниц от 1 до последней страницы
    state.pagination.pageList.pages = [...Array(paginationData.last_page).keys()].map(i => ++i)
  },
  TOGGLE_EMPLOYMENT_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = !state.pagination.pageList.active
  },
  CLOSE_EMPLOYMENT_LIST_PAGE_LIST: (state) => {
    state.pagination.pageList.active = false
  }
}

const actions = {
  getEmployments ({ state, commit }) {
    axios.get(`${url}/employments?per-page=1`, config).then(response => {
      axios.get(`${url}/employments?sort=-id&per-page=${response.headers['x-pagination-total-count']}`, config).then(response => {
        commit('GET_EMPLOYMENTS', response.data.data)
      })
    }).catch(error => {
      console.log('ошибка получения списка видов занятости', error.response ? error.response : error)
    })
  },
  // раскомментить и отредактировать когда будет пагинация
  /* getPositionListPrevPage ({ state, commit }) {
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage - 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListNextPage ({ state, commit }) {
    const currentTake = state.pagination.currentTake
    const currentPage = state.pagination.currentPage
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${currentPage + 1}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
      commit('CLOSE_POSITION_LIST_PAGE_LIST')
    })
  },
  getPositionListPage ({ state, commit }, pageNum) {
    const currentTake = state.pagination.currentTake
    axios.get(`${url}/positions?orderBy=id&orderDir=DESC&take=${currentTake}&page=${pageNum}`, config).then(response => {
      commit('GET_POSITIONS', response.data.data)
      commit('SET_POSITION_LIST_PAGINATION', response.data)
    })
  },
  togglePositionListPageList ({ commit }) {
    commit('TOGGLE_POSITION_LIST_PAGE_LIST')
  }, */
  // переключение всплывающих меню (ред./удалить)
  toggleEmploymentListItemControls ({ commit }, itemId) {
    commit('EMPLOYMENT_LIST_TOGGLE_CONTROLS', itemId)
  },
  // показ модалки редактирования записи
  showEmploymentListUpdateModal ({ commit }, employmentId) {
    commit('SHOW_EMPLOYMENT_LIST_UPDATE_MODAL', employmentId)
  },
  // редактирование имени записи
  setUpdatedEmploymentName ({ commit }, name) {
    commit('SET_UPDATED_EMPLOYMENT_NAME', name)
  },
  // показ модалки создания записи
  showEmploymentListCreateModal ({ commit }) {
    commit('SHOW_EMPLOYMENT_LIST_CREATE_MODAL')
  },
  // редактирование имени новой записи
  setCreatedEmploymentName ({ commit }, name) {
    commit('SET_CREATED_EMPLOYMENT_NAME', name)
  },
  // закрытие всех модалок
  closeEmploymentListModals ({ commit }) {
    commit('CLOSE_EMPLOYMENT_LIST_MODALS')
    // закрываем все всплывашки (ред./удалить)
    commit('CLOSE_EMPLOYMENT_LIST_CONTROLS')
  },
  // создание записи
  createEmployment ({ commit, state }) {
    if (state.createModal.newEmploymentName) {
      const postData = {
        name: state.createModal.newEmploymentName
      }

      axios.post(`${url}/employments`, postData, config).then(response => {
        this.dispatch('getEmployments')
        this.dispatch('closeEmploymentListModals')
      }).catch(error => {
        console.log('Ошибка создания вида занятости:' + error)
      })
    } else {
      commit('SET_EMPLOYMENT_LIST_MODAL_VALIDATION', { modal: 'create', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // редактирование записи
  updateEmployment ({ commit, state }) {
    if (state.updateModal.employment.name) {
      const employmentData = {
        id: state.updateModal.employment.id,
        name: state.updateModal.employment.name
      }

      axios.put(`${url}/employments/${employmentData.id}`, employmentData, config).then(response => {
        this.dispatch('getEmployments')
        this.dispatch('closeEmploymentListModals')
      }).catch(error => {
        console.log('Ошибка редактирования вида занятости:' + error)
      })
    } else {
      commit('SET_EMPLOYMENT_LIST_MODAL_VALIDATION', { modal: 'update', validation: { type: 'error', message: 'Поле должно быть заполнено' } })
    }
  },
  // очищаем поля валидации
  clearEmploymentListModalValidation ({ commit }) {
    commit('SET_EMPLOYMENT_LIST_MODAL_VALIDATION', { modal: null, validation: null })
  },
  // удаление записи
  deleteEmployment ({ commit }, employmentId) {
    axios.delete(`${url}/employments/${employmentId}`, config).then(response => {
      console.log('Вид занятости успешно удален')
      this.dispatch('getEmployments')
      this.dispatch('closeEmploymentListModals')
    }).catch(error => {
      console.log('Ошибка удаления вида занятости:' + error)
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
